import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PDV_FEATURE } from '../actions/pdv.actions';
import { PdvState } from '../reducers/pdv.reducer';

const featureSelector = createFeatureSelector<PdvState>(PDV_FEATURE);

export const selectLoader = createSelector(
  featureSelector,
  (state) => state.loading
);

export const selectCompany = createSelector(
  featureSelector,
  (state) => state.company
);

export const selectPdvConfigs = createSelector(
  featureSelector,
  (state) => state.settings
);

export const selectEvents = createSelector(
  featureSelector,
  (state) => state.events
);
